module.exports = __webpack_public_path__ + "static/img/hk_img.ded0dbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hk_img.jpg
// module id = uW19
// module chunks = 4